(() => {
  const header = document.querySelector('[data-ko-header]');
  if (header) {
    const menu = header.querySelector('[data-ko-mobile-menu]');
    const scrim = header.querySelector('[data-ko-scrim]');
    const open = header.querySelector('[data-ko-menu-open]');
    const close = header.querySelector('[data-ko-menu-close]');
    const setMenu = (value) => {
      menu?.classList.toggle('is-open', value);
      scrim?.classList.toggle('is-open', value);
      menu?.setAttribute('aria-hidden', String(!value));
      open?.setAttribute('aria-expanded', String(value));
      document.documentElement.classList.toggle('ko-menu-open', value);
    };
    open?.addEventListener('click', () => setMenu(true));
    close?.addEventListener('click', () => setMenu(false));
    scrim?.addEventListener('click', () => setMenu(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMenu(false);
    });

    const menus = [...header.querySelectorAll('.ko-nav > details')];
    menus.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        menus.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
        item.setAttribute('open', '');
      });
      item.addEventListener('mouseleave', () => item.removeAttribute('open'));
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) menus.forEach((item) => item.removeAttribute('open'));
    });
  }

  const initializeProductTabs = (root = document) => {
    root.querySelectorAll('[data-ko-product-tabs]').forEach((section) => {
      if (section.dataset.koTabsReady === 'true') return;
      const tabs = [...section.querySelectorAll('[data-ko-product-tab]')];
      const panels = [...section.querySelectorAll('[data-ko-product-panel]')];
      const shopAll = section.querySelector('[data-ko-tabs-shop-all]');
      if (!tabs.length || !panels.length) return;

      const activate = (tab, moveFocus = false) => {
        const key = tab.dataset.koProductTab;
        tabs.forEach((candidate) => {
          const selected = candidate === tab;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-selected', String(selected));
          candidate.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.koProductPanel === key;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });
        if (shopAll && tab.dataset.collectionUrl) shopAll.href = tab.dataset.collectionUrl;
        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === null) return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });
      section.dataset.koTabsReady = 'true';
      activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
    });
  };

  initializeProductTabs();
  document.addEventListener('shopify:section:load', (event) => initializeProductTabs(event.target));

  const initializeFooter = (root = document) => {
    root.querySelectorAll('[data-ko-footer]').forEach((footer) => {
      if (footer.dataset.koFooterReady === 'true') return;
      const groups = [...footer.querySelectorAll('.ko-footer__links details')];
      const mobile = window.matchMedia('(max-width: 749px)');
      const applyViewport = () => groups.forEach((group) => {
        if (mobile.matches) group.removeAttribute('open');
        else group.setAttribute('open', '');
      });
      applyViewport();
      mobile.addEventListener?.('change', applyViewport);
      footer.dataset.koFooterReady = 'true';
    });
  };

  initializeFooter();
  document.addEventListener('shopify:section:load', (event) => initializeFooter(event.target));

  let toastTimer;
  const syncCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((response) =>
      response.json(),
    );
    document.querySelectorAll('.ko-cart-count').forEach((node) => {
      node.classList.toggle('hidden', !cart.item_count);
      node.textContent = String(cart.item_count);
    });
    return cart;
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => syncCart().catch(() => {}));
  }

  const toast = (title) => {
    let node = document.querySelector('.ko-cart-toast');
    if (!node) {
      node = document.createElement('div');
      node.className = 'ko-cart-toast';
      node.setAttribute('role', 'status');
      document.body.append(node);
    }
    node.innerHTML = `<strong>ITEM ADDED TO YOUR CART</strong><span>${title || 'Your item is ready.'}</span><a href="/cart">VIEW CART</a>`;
    node.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => node.classList.remove('is-visible'), 4200);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.ko-quick-add');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('Cart request failed');
      const item = await response.json();
      await syncCart();
      toast(item.product_title || item.title);
    } catch {
      window.location.href = '/cart';
    } finally {
      button.disabled = false;
    }
  });
})();
